// extracted by mini-css-extract-plugin
module.exports =  {"content":"a10a3f92e9--content--hP0Dq","header":"a10a3f92e9--header--NuUUO","close-button":"a10a3f92e9--close-button--GAUzQ","reset-button":"a10a3f92e9--reset-button--sub6E"};